import { Action, Dispatch, ActionCreator } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { Action as SetHasBannerAction, ActionTypes } from './types';
import { AppState } from '..';

export const setHasBanner: ActionCreator<ThunkAction<void, AppState, null, Action<SetHasBannerAction>>> =
  (hasBanner: boolean) =>
    (dispatch: Dispatch<SetHasBannerAction>): void => {
      dispatch({
        type: ActionTypes.SET_HAS_BANNER,
        hasBanner
      });
    };

